import { render, staticRenderFns } from "./TraxTrainingGroupRegistrationCrudForm.vue?vue&type=template&id=6b07f61e"
import script from "./TraxTrainingGroupRegistrationCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingGroupRegistrationCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports